function vacinas(){
	return {
		"games":[
			{
				"informs":[
					{
						"text":"Quando nossa defesa natural não consegue eliminar um agente patogênico (como o vírus SARS-CoV-2) ele causará uma infecção que acarretará os sintomas da doença (COVID-19).",
						"title":"Vacinas: o que são e para que servem?",
						"image":"images/games/informs/vacinas/1.png",
                    },
					{
						"text":"Como ainda não foi descoberto remédios para tratar esta doença, o controle da pandemia poderá ser alcançado pela vacinação da população.",
						"title":"Vacinas: o que são e para que servem?",
						"image":"images/games/informs/vacinas/1.png",
                    },
					{
						"text":"As vacinas funcionam simulando  uma infecção ao sistema imunológico.",
						"title":"Vacinas: o que são e para que servem?",
						"image":"images/games/informs/vacinas/1.png",
                    },
					{
						"text":"As Vacinas podem ser  compostas de vírus atenuados, mortos ou componentes isolados dos mesmos, denominados antígenos, isto é, uma substância estranha ao organismo.",
						"title":"Vacinas: o que são e para que servem?",
						"image":"images/games/informs/vacinas/1.png",
                    },
					{
						"text":"Ao receber uma vacina, o sistema de defesa  começa a reconhecer as substâncias que a compõem (porque são estranhas a ele), iniciando uma resposta imune primária específica.",
						"title":"Vacinas: o que são e para que servem?",
						"image":"images/games/informs/vacinas/1.png",
                    },
					{
						"text":"Células do sistema imunológico, particularmente os linfócitos, formarão um clone de células comprometidas com as substâncias presentes na vacina, chamadas “células de memória”",
						"title":"Vacinas: o que são e para que servem?",
						"image":"images/games/informs/vacinas/1.png",
                    },
					{
						"text":"Dessa forma, se entrarmos em contato com o SARS-CoV-2, já teremos as “células de memória” que irão rapidamente produzir anticorpos contra ele e eliminá-lo.",
						"title":"Vacinas: o que são e para que servem?",
						"image":"images/games/informs/vacinas/1.png",
                    }
				],
				"pathImageGame":"midias/images/games/puzzles/vacinas/1.png"
			}
		]
	};
}

export {vacinas};
